import React from 'react';
import {useIntl} from "react-intl";
import {connect} from "react-redux";
import {Checkbox, DatePicker} from "antd";
import moment from "moment";
import Constants from "../../../../services/Constants";
import {getFilters} from "../../../../selectors/interventionsSelector";

const CheckboxGroup = Checkbox.Group;
const DATE_FORMAT = Constants.DATE_FORMAT_DISPLAY;
const DATE_FORMAT_API = Constants.DATE_FORMAT_API;

const FilterDate = ({apiKeyStart, apiKeyEnd, filter, contentUpdater, filters,}) => {
  const intl = useIntl();

  const filterOnChange = (apiKey, checkedValues) => {
    filter.selectedKeys[0] = checkedValues;
    (checkedValues && checkedValues.length > 0) ? filter.confirm() : filter.clearFilters();
    contentUpdater({[apiKey]: checkedValues});
  };

  const dateOnChange = (apiKey, zonedTime) => {
    const date = zonedTime === null ? [] : zonedTime.format(DATE_FORMAT_API);
    filterOnChange(apiKey, date);
  };

  const startDate = (filters || {})[apiKeyStart] && typeof filters[apiKeyStart] === 'string' ? moment(filters[apiKeyStart]) : undefined;
  const endDate = (filters || {})[apiKeyEnd] && typeof filters[apiKeyEnd] === 'string' ? moment(filters[apiKeyEnd]) : undefined;

  return (
    <CheckboxGroup className="dropdown dropdown--sm dropdown--bottom-right">
      <DatePicker
        placeholder={intl.formatMessage({id: 'placeholder.startDate'})}
        format={DATE_FORMAT}
        onChange={(zonedTime) => dateOnChange(apiKeyStart, zonedTime)}
        value={startDate}
      />
      <DatePicker
        placeholder={intl.formatMessage({id: 'placeholder.endDate'})}
        format={DATE_FORMAT}
        onChange={(zonedTime) => dateOnChange(apiKeyEnd, zonedTime)}
        value={endDate}
      />
    </CheckboxGroup>
  );
};

const mapStateToProps = state => ({
  filters: getFilters(state)
});

export default connect(mapStateToProps)(FilterDate);
